import React from 'react';
import SideMenuBar from '../../../Components/Layouts/SideMenuBar';
import TopMenuBar from '../../../Components/Layouts/TopMenuBar';
import RightSideBar from '../../../Components/Layouts/RightSideBar';
import MyTickets from './MyTickets';
import '../../../Styles/Reels/ReelsIndex.css';

function MyTicketsInApp() {
    return (
        <div className="reels-dashboard">
            <div className="topmenubar">
                <SideMenuBar />
                <div className="top-bar-mobile">
                    <TopMenuBar backIconVisible={false} tabName="My Tickets" />
                </div>
            </div>

            <div className="main-container">
                <div className="video-container main-container-reels">
                    <MyTickets embed />
                </div>
                <RightSideBar />
            </div>
        </div>
    );
}

export default MyTicketsInApp;

